// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__9sJTo","img":"Footer_img__2Dj40","buttons":"Footer_buttons__yn8G6"};